import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { AuthPageRoutingModule } from './auth-routing.module';
import { AuthPage } from './auth.page';
import { ForgotPasswordComponentModule } from './forgot-password/forgot-password.component.module';
import { LoginComponentModule } from './login/login.component.module';
import { SignupComponentModule } from './signup/signup.component.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		AuthPageRoutingModule,
		ForgotPasswordComponentModule,
		LoginComponentModule,
		SignupComponentModule
	],
	declarations: [AuthPage],
})
export class AuthPageModule { }
